import { useState, useRef } from 'react';
import Modal from '@mui/material/Modal';
import { useTranslation } from "react-i18next"
import { MenuFoldOutlined } from '@ant-design/icons';
import { css, StyleSheet } from 'aphrodite';
import { styled, Box, Typography, Switch } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import NotificationsIcon from '@mui/icons-material/Notifications';

import ButtonGradient from '../../common/button-gradient';
import { SVGImageComponentReact } from '../../themes/Images';
import { useSelector } from 'react-redux';
import "./modal.style.css"
import { Table } from 'antd'
import { translate } from '../../helper';
import poweredBy from '../../assets/image/png/PoweredByMove_logo-100.jpg';
import { ENV } from '../../Env';
import { resolveCssVarValue } from '../../utils/CommonFunction';
import AppleIcon from '@mui/icons-material/Apple';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';


const GoogleIcon = (props) => (
    <svg width={20} height={20} viewBox="0 0 48 48" {...props}>
        <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C33.3 6.1 28.9 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20c11.5 0 20-9.3 20-20 0-1.3-.1-2.7-.4-3.9z" />
        <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.5 16.1 19 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C33.3 6.1 28.9 4 24 4 16.1 4 9.5 8.5 6.3 14.7z" />
        <path fill="#4CAF50" d="M24 44c5.4 0 10.3-2.1 13.9-5.4l-6.4-5.2c-2 1.4-4.6 2.2-7.5 2.2-5.3 0-9.7-3.4-11.3-8l-6.6 5.1C9.5 39.5 16.1 44 24 44z" />
        <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.7 2-2.1 3.7-3.8 4.9l6.4 5.2C39.9 35.4 44 30.2 44 24c0-1.3-.1-2.7-.4-3.5z" />
    </svg>
);

const styles = StyleSheet.create({
    iconNotification: {
        width: "calc(var(--fs-xs) * 1.50943)",
        height: "calc(var(--fs-xs) * 1)",
        marginRight: "var(--sp-md2)",
        cursor: 'pointer'
    },
    iconNoNotification: {
        width: "calc(var(--fs-xs) * 1.132075)",
        height: "calc(var(--fs-xs) * 1.132075)",
        marginRight: "var(--sp-xs)",
        cursor: 'pointer'
    },
    iconUser: {
        width: "calc(var(--fs-xl) * 1.132075)",
        height: "calc(var(--fs-xl) * 1.132075)",
        borderRadius: "calc(var(--sp-md2) * 1.4150943)",
        marginLeft: "var(--sp-md2)",
        marginRight: "var(--sp-md2)",
        border: `solid 2px #F2F2F2`
    }
});

const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: "calc(var(--fs-xs) * 3.018867)",
    height: "calc(var(--fs-xs) * 1.50943)",
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: "0.1rem",
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(calc(var(--fs-xs) * 1.50943))',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#ddd',
                opacity: 1,
                border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: 'calc(var(--sp-sm)) solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color:
                theme.palette.mode === 'light'
                    ? theme.palette.grey[100]
                    : theme.palette.grey[600],
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: "calc(var(--fs-xs) * 1.207547)",
        height: "calc(var(--fs-xs) * 1.207547)",
    },
    '& .MuiSwitch-track': {
        borderRadius: "calc(var(--sp-md2) * 1.226415)",
        backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}));

const settings = {
    dots: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
};

function PreviewModal({ isOpen, onClose, type, webTheme, mobTheme, orderForm, orderBackgroundColor, emailData, onSubmit, loading }) {
    const { t } = useTranslation()
    const { userInfo } = useSelector(state => state?.User)
    const whiteLabel = useSelector((state) => state.User?.branding);
    const [showSignInScreen, setShowSignInScreen] = useState(true);

    let height = window.innerHeight;
    let width = window.innerWidth;
    const {
        sideBannerColor,
        topBannerColor,
        buttonColor,
        logo
    } = webTheme

    const {
        mobileTopBannerColor: mobTopBannerColor,
        mobileButtonColor: mobButtonColor,
        mobileLogo: mobLogo
    } = mobTheme

    const {
        emailBackgroundColor,
        emailLogo,
        emailTemplate
    } = emailData
    function imageUrl(url) {
        if (url?.type) {
            return URL.createObjectURL(url)
        }
        return url
    }

    return (
        <Modal open={isOpen} onClose={onClose}>
            <div
                style={{
                    width: width,
                    height: height,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <div
                    style={{
                        width: width * 0.5,
                        height: type === "mob" ? height * 0.9 : height * 0.8,
                        backgroundColor: "#fff",
                        display: "flex",
                        flexDirection: "column",
                        padding: "calc(var(--sp-md2) * 1.886792) calc(var(--sp-lg) * 1.886792)",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            height: "90%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                    >
                        {type === "web" && (
                            <div
                                style={{
                                    width: "100%",
                                    height: `${(height * 0.5) - resolveCssVarValue('--fs-xl') * 1.886792}px`,
                                    display: "flex",
                                    flexDirection: "column",
                                    border: "1px solid #ddd",
                                    background: "#fff"
                                }}
                            >
                                <div
                                    style={{
                                        width: "100%",
                                        height: "9%",
                                        backgroundColor: `rgba(${topBannerColor?.r}, ${topBannerColor?.g}, ${topBannerColor?.b}, ${topBannerColor?.a})`,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between"
                                    }}
                                >
                                    <>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <MenuFoldOutlined
                                                style={{
                                                    fontSize: "calc(var(--fs-xs)*0.754716)",
                                                    color: "#fff",
                                                    marginLeft: "var(--sp-md2)",
                                                    marginRight: "calc(var(--sp-md2)*1.4150943)",
                                                }}
                                            />
                                            <span
                                                style={{
                                                    fontWeight: "600",
                                                    color: "#fff",
                                                    fontSize: "calc(var(--fs-xs)*0.754716)",
                                                }}
                                            >
                                                {userInfo?.user?.vendor?.business_name || 'N/A'}
                                            </span>
                                        </div>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <SVGImageComponentReact.IconNotes style={{ width: "calc(var(--fs-xs)*1.4150943)", height: "calc(var(--fs-xs)*1.4150943)", marginRight: "var(--sp-xs)" }} />
                                            <SVGImageComponentReact.NoNotificationsIcon style={{ width: "calc(var(--fs-xs)*1.4150943)", height: "calc(var(--fs-xs)*1.4150943)", marginRight: "var(--sp-xs)", fontSize: "calc(var(--fs-xs)*0.754716)" }} />
                                            <span style={{ fontSize: "calc(var(--fs-xs)*0.754716)", color: "#fff", paddingRight: "var(--sp-xs)", borderRight: "1px solid #000" }}>{t('Notifications')}</span>
                                            <div className="layout-username" style={{ display: "flex" }}>
                                                <div className="flex-column">
                                                    <span className="header-user-name" style={{ fontSize: "calc(var(--fs-xs)*0.754716)" }}>
                                                        {userInfo?.user?.first_name ? userInfo?.user?.first_name + (' ' + userInfo?.user?.last_name || '') : userInfo?.user?.name}
                                                    </span>
                                                    <span className="header-user-email" style={{ fontSize: "calc(var(--fs-xs)*0.754716)" }}>
                                                        {userInfo?.user?.email || 'Email'}
                                                    </span>
                                                </div>
                                                {userInfo?.profile?.profile_image ? (
                                                    <img
                                                        src={userInfo?.profile?.profile_image}
                                                        className={css(styles.iconUser)}
                                                        alt="avatar"
                                                    />
                                                ) : (
                                                    <SVGImageComponentReact.IconUser className={css(styles.iconUser)} />
                                                )}
                                                <SVGImageComponentReact.IconDropDown
                                                    style={{ marginRight: "calc(var(--sp-md2)*1.4150943)", fontSize: "calc(var(--fs-xs)*0.754716)", height: "calc(var(--fs-xs)*1.32075)", width: "calc(var(--fs-xs)*1.32075)" }}
                                                />
                                            </div>
                                        </div>
                                    </>
                                </div>
                                <div
                                    style={{
                                        width: "100%",
                                        height: "91%",
                                        backgroundColor: `#fff`,
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "stretch",
                                        minHeight: 0,
                                        flex: 1,
                                    }}
                                >
                                    <div
                                        style={{
                                            width: "15%",
                                            height: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            background: "#fff",
                                        }}
                                    >
                                        <div style={{ backgroundColor: "#fff", height: "12%", padding: "var(--sp-xs)" }} className='logo'>
                                            <img style={{ height: "100%", width: "unset" }} src={imageUrl(logo)} alt='logo' />
                                        </div>
                                        <ul
                                            style={{
                                                paddingLeft: "var(--sp-md2)",
                                                flex: 1,
                                                backgroundColor: `rgba(${sideBannerColor?.r}, ${sideBannerColor?.g}, ${sideBannerColor?.b}, ${sideBannerColor?.a})`,
                                                borderTopRightRadius: "var(--sp-xs)",
                                                marginBottom: "0",
                                                borderBottomRightRadius: "var(--sp-xs)",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "flex-start",
                                                gap: "var(--sp-md2)",
                                            }}
                                        >
                                            <li style={{ display: "flex", listStyleType: "none", alignItems: 'center', paddingLeft: "var(--sp-md2)", marginTop: 'var(--sp-md2)', fontSize: "calc(var(--fs-xs)*0.754716)" }}>
                                                <SVGImageComponentReact.IconMenuOrder style={{ width: "calc(var(--fs-xs)*1.4150943)", height: "calc(var(--fs-xs)*1.4150943)" }} />
                                                <span style={{ color: "#fff", fontWeight: "500", marginLeft: "var(--sp-xs)" }} className="nav-text">{t('orders')}</span>
                                            </li>
                                            <li style={{ display: "flex", listStyleType: "none", alignItems: 'center', paddingLeft: "var(--sp-md2)", margin: 0, fontSize: "calc(var(--fs-xs)*0.754716)" }}>
                                                <SVGImageComponentReact.IconDashBoardApp style={{ width: "calc(var(--fs-xs)*1.4150943)", height: "calc(var(--fs-xs)*1.4150943)" }} />
                                                <span style={{ color: "#fff", fontWeight: "500", marginLeft: "var(--sp-xs)" }} className="nav-text">{t('allLocationsOrders')}</span>
                                            </li>
                                            <li style={{ display: "flex", listStyleType: "none", alignItems: 'center', paddingLeft: "var(--sp-md2)", margin: 0, fontSize: "calc(var(--fs-xs)*0.754716)" }}>
                                                <SVGImageComponentReact.ServiceIcon style={{ width: "calc(var(--fs-xs)*1.4150943)", height: "calc(var(--fs-xs)*1.4150943)" }} />
                                                <span style={{ color: "#fff", fontWeight: "500", marginLeft: "var(--sp-xs)" }} className="nav-text">{t('service')}</span>
                                            </li>
                                            <li style={{ display: "flex", listStyleType: "none", alignItems: 'center', paddingLeft: "var(--sp-md2)", margin: 0, borderRight: "calc(var(--sp-xxs)*0.707547) solid #fbb516", fontSize: "calc(var(--fs-xs)*0.754716)" }}>
                                                <SVGImageComponentReact.IconNotesActive style={{ width: "calc(var(--fs-xs)*1.4150943)", height: "calc(var(--fs-xs)*1.4150943)" }} />
                                                <span style={{ color: "#fbb516", fontWeight: "500", marginLeft: "var(--sp-xs)" }} className="nav-text">{t('vendorNotes')}</span>
                                            </li>
                                            <li style={{ display: "flex", listStyleType: "none", alignItems: 'center', paddingLeft: "var(--sp-md2)", margin: 0, fontSize: "calc(var(--fs-xs)*0.754716)" }}>
                                                <SVGImageComponentReact.IconChart style={{ width: "calc(var(--fs-xs)*1.4150943)", height: "calc(var(--fs-xs)*1.4150943)" }} />
                                                <span style={{ color: "#fff", fontWeight: "500", marginLeft: "var(--sp-xs)" }} className="nav-text">{t('analytics')}</span>
                                            </li>
                                            <li style={{ display: "flex", listStyleType: "none", alignItems: 'center', paddingLeft: "var(--sp-md2)", margin: 0, fontSize: "calc(var(--fs-xs)*0.754716)" }}>
                                                <SVGImageComponentReact.IconQuotes style={{ width: "calc(var(--fs-xs)*1.4150943)", height: "calc(var(--fs-xs)*1.4150943)" }} />
                                                <span style={{ color: "#fff", fontWeight: "500", marginLeft: "var(--sp-xs)" }} className="nav-text">{t('acceptedQuotes')}</span>
                                            </li>
                                        </ul>
                                        <div style={{ backgroundColor: "#fff", height: "15%" }} className='logo'>
                                            <img src={imageUrl(poweredBy)} style={{ height: "100%", width: "unset" }} alt='logo' />
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            width: "85%",
                                            height: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            background: "#fff",
                                            minHeight: 0,
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: "100%",
                                                height: "90%",
                                                backgroundColor: `#fff`,
                                                display: "flex",
                                                flexDirection: "column",
                                                padding: "calc(var(--sp-md2)*1.886792)",
                                                minHeight: 0,
                                                flex: 1,
                                            }}
                                        >
                                            <span style={{ fontWeight: "500", marginBottom: "var(--sp-md2)", fontSize: "calc(var(--fs-xs)*0.754716)" }}>
                                                {t('vendorNotes')}
                                            </span>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    width: "100%",
                                                    marginBottom: "var(--sp-md2)",
                                                }}
                                            >
                                                <input
                                                    style={{
                                                        height: "calc(var(--fs-xl)*1.4150943)",
                                                        borderRadius: "calc(var(--sp-xxs)*0.47169) !important",
                                                        width: "calc(var(--fs-hero)*3.537736) !important",
                                                        boxShadow: "none",
                                                        border: "none",
                                                        paddingLeft: "var(--sp-md2)",
                                                        fontSize: "calc(var(--fs-xs)*0.754716) !important",
                                                        border: "1px solid #ddd"
                                                    }}
                                                    placeholder={t('searchVendorNotes')}
                                                    disabled
                                                />
                                                <ButtonGradient
                                                    title={t('create')}
                                                    backgroundColor={`rgba(${buttonColor?.r}, ${buttonColor?.g}, ${buttonColor?.b}, ${buttonColor?.a})`}
                                                    style={{
                                                        background: `rgba(${buttonColor?.r}, ${buttonColor?.g}, ${buttonColor?.b}, ${buttonColor?.a})`,
                                                        width: "25%",
                                                        maxWidth: "calc(var(--fs-hero)*3.537736) !important",
                                                        height: "calc(var(--fs-xl)*1.4150943)",
                                                        fontSize: "calc(var(--fs-xs)*0.754716)",
                                                    }}
                                                    textStyle={{
                                                        fontSize: "calc(var(--fs-xs)*0.754716)",
                                                        textTransform: "uppercase"
                                                    }}
                                                />
                                            </div>
                                            <div
                                                style={{
                                                    width: "100%",
                                                    overflowY: "hidden",
                                                    background: "#fff",
                                                }}
                                            >

                                                <Table
                                                    className="preview-ant-table"
                                                    columns={[
                                                        {
                                                            id: 'customer_po',
                                                            title: t('customerPo'),
                                                            minWidth: "calc(var(--fs-hero)*2.358493)",
                                                            size: "calc(var(--fs-xs)*0.754716)",
                                                        },
                                                        {
                                                            id: 'order_name',
                                                            title: t('orderName'),
                                                            minWidth: "calc(var(--fs-hero)*4.0094)",
                                                            size: "calc(var(--fs-xs)*0.754716)",
                                                        },
                                                        {
                                                            id: 'timestamp',
                                                            title: t('dateCreated'),
                                                            minWidth: "calc(var(--fs-hero)*2.358493)",
                                                            size: "calc(var(--fs-xs)*0.754716)",
                                                        },
                                                        {
                                                            id: 'note_number',
                                                            title: t('vendorNoteNumber'),
                                                            minWidth: "calc(var(--fs-hero)*4.0094)",
                                                            size: "calc(var(--fs-xs)*0.754716)",
                                                        },
                                                        {
                                                            id: 'action',
                                                            title: '',
                                                            size: "calc(var(--fs-xs)*0.754716)",
                                                            minWidth: "calc(var(--fs-hero)*2.358493)",
                                                        },
                                                    ]}
                                                    data={window.vendorNotesData || []}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {type === "mob" && (
                            <div
                                style={{
                                    width: "50%",
                                    maxWidth: "calc(var(--fs-hero)*8.254717)",
                                    height: `100%`,
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                <div
                                    style={{
                                        width: "100%",
                                        padding: "calc(var(--sp-md2)*1)",
                                        display: "flex",
                                        height: "90%",
                                        flexDirection: "column",
                                        borderRadius: "var(--sp-xs)",
                                    }}
                                >
                                    {showSignInScreen ? (
                                        <div
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                display: "flex",
                                                flexDirection: "column",
                                                border: "1px solid #ddd",
                                                background: "#fff",
                                                boxSizing: 'border-box',
                                                padding: 'calc(var(--sp-lg) * 1.132075) calc(var(--sp-md2) * 1.886792)',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    marginTop: 0,
                                                }}
                                            >
                                                <img style={{ width: "30%", marginBottom: "calc(var(--sp-md2) * 1.50943)" }} src={imageUrl(mobLogo)} alt="logo" />
                                                <div style={{ fontWeight: "bold", fontSize: "calc(var(--fs-xl) * 1.50943)", marginBottom: "calc(var(--sp-xxs) * 2)" }}>Welcome</div>
                                                <div style={{ color: "#888", marginBottom: "calc(var(--sp-lg) * 1.132075)", textAlign: "center" }}>
                                                    Please enter your email to get started.
                                                </div>
                                                <span style={{ alignSelf: "flex-start", fontSize: 'calc(var(--fs-xs)*1.2)', marginBottom: "calc(var(--sp-xxs) * 2)" }}>{t('email')}</span>
                                                <input
                                                    placeholder="name@gmail.com"
                                                    style={{
                                                        width: "100%",
                                                        height: "calc(var(--fs-xl)*1.886792)",
                                                        backgroundColor: "#fff",
                                                        marginBottom: "calc(var(--sp-lg) * 1.132075)",
                                                        borderRadius: "calc(var(--sp-xs) * 1)",
                                                        border: "1px solid #ddd",
                                                        fontSize: 'calc(var(--fs-xs)*1.132075)',
                                                        padding: "0 calc(var(--sp-md2) * 1.50943)",
                                                    }}
                                                    disabled
                                                    id="input"
                                                />
                                                <ButtonGradient
                                                    title={t('continue')}
                                                    backgroundColor={`rgba(${mobButtonColor?.r}, ${mobButtonColor?.g}, ${mobButtonColor?.b}, ${mobButtonColor?.a})`}
                                                    style={{
                                                        backgroundColor: `rgba(${mobButtonColor?.r}, ${mobButtonColor?.g}, ${mobButtonColor?.b}, ${mobButtonColor?.a})`,
                                                        width: "100%",
                                                        fontSize: "calc(var(--fs-xs)*1.132075)",
                                                        marginBottom: "calc(var(--sp-lg) * 1.132075)",
                                                        cursor: 'default'
                                                    }}
                                                    textStyle={{
                                                        fontSize: "calc(var(--fs-xs)*1.132075)",
                                                    }}
                                                />
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        width: '100%',
                                                        margin: 'calc(var(--sp-md2) * 1.88679) 0',
                                                    }}
                                                >
                                                    <div style={{ flex: 1, height: 0, borderBottom: '1.5px solid #e0e0e0', marginRight: 'calc(var(--sp-md2) * 1.132075)' }} />
                                                    <Typography sx={{ color: 'rgba(116, 116, 116, 1)', fontSize: "calc(var(--fs-xs)*1.50943)", fontWeight: 600, whiteSpace: 'nowrap' }}>OR</Typography>
                                                    <div style={{ flex: 1, height: 0, borderBottom: '1.5px solid #e0e0e0', marginLeft: 'calc(var(--sp-md2) * 1.132075)' }} />
                                                </div>
                                                <div style={{ marginTop: 'calc(var(--sp-md2) * 1.50943)', width: '100%' }}>
                                                    {[
                                                        { key: 'google', icon: <GoogleIcon />, label: 'Continue with Google' },
                                                        { key: 'apple', icon: <AppleIcon className="social-btn__appleIcon" />, label: 'Continue with Apple' },
                                                    ].map(({ key, icon, label, onClick }) => (
                                                        <Box
                                                            key={key}
                                                            className="social-btn"
                                                            onClick={onClick}
                                                            sx={{
                                                                width: '100%',
                                                                marginBottom: 'calc(var(--sp-xxs) * 2)',
                                                                padding: 'calc(var(--sp-xxs) * 2) calc(var(--sp-md2) * 1)',
                                                                background: '#232742',
                                                                borderRadius: 'calc(var(--sp-md2) * 1)',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between',
                                                                cursor: 'default'

                                                            }}
                                                        >
                                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                                <Box sx={{ marginRight: 'calc(var(--sp-xxs) * 2)', display: 'flex', alignItems: 'center' }}>{icon}</Box>
                                                                <Typography sx={{ color: '#fff', fontSize: 'calc(var(--fs-xs) * 1.32075)', fontWeight: 500 }}>{label}</Typography>
                                                            </Box>
                                                            <ArrowForwardIosIcon sx={{ color: '#fff', fontSize: 'calc(var(--fs-xs) * 1.50943)' }} />
                                                        </Box>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                display: "flex",
                                                flexDirection: "column",
                                                border: "1px solid #ddd",
                                                background: "#fff",
                                                position: 'relative'
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: "100%",
                                                    height: "20%",
                                                    backgroundColor: `rgba(${mobTopBannerColor?.r}, ${mobTopBannerColor?.g}, ${mobTopBannerColor?.b}, ${mobTopBannerColor?.a})`,
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    borderTopLeftRadius: "calc(var(--sp-md2)*1.886792)",
                                                    borderTopRightRadius: "calc(var(--sp-md2)*1.886792)",
                                                }}
                                            >
                                                <img style={{ width: "25%" }} src={imageUrl(mobLogo)} alt="logo" />
                                            </div>
                                            <div
                                                style={{
                                                    width: "100%",
                                                    height: "80%",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    padding: "calc(var(--sp-lg) * 1.50943) calc(var(--sp-lg) * 1.132075)",
                                                    background: "#fff",
                                                    borderBottomLeftRadius: "calc(var(--sp-md2)*1.886792)",
                                                    borderBottomRightRadius: "calc(var(--sp-md2)*1.886792)",
                                                }}
                                            >
                                                <div style={{ fontWeight: "bold", fontSize: "calc(var(--fs-xl)*1.132075)", margin: "calc(var(--sp-md2) * 1.50943) 0" }}>{t('forgotPassword')}</div>
                                                <span style={{ alignSelf: "flex-start", fontSize: 'calc(var(--fs-xs)*1.2)', marginBottom: "calc(var(--sp-xxs) * 2)" }}>{t('email')}</span>
                                                <input
                                                    placeholder="name@gmail.com"
                                                    style={{
                                                        width: "100%",
                                                        height: "calc(var(--fs-xl)*1.886792)",
                                                        backgroundColor: "#f5f5f5",
                                                        marginBottom: "calc(var(--sp-lg) * 1.132075)",
                                                        borderRadius: "calc(var(--sp-xs) * 1)",
                                                        border: "1px solid #ddd",
                                                        fontSize: 'calc(var(--fs-xs)*1.132075)',
                                                        padding: "0 calc(var(--sp-md2) * 1.50943)",
                                                    }}
                                                    disabled
                                                    id="input"
                                                />
                                                <div style={{ color: "#888", marginBottom: "calc(var(--sp-lg) * 1.50943)", textAlign: "center" }}>
                                                    We will send a verification link to your email to reset your password.
                                                </div>
                                                <ButtonGradient
                                                    title={t('resetPassword')}
                                                    backgroundColor={`rgba(${mobButtonColor?.r}, ${mobButtonColor?.g}, ${mobButtonColor?.b}, ${mobButtonColor?.a})`}
                                                    style={{
                                                        backgroundColor: `rgba(${mobButtonColor?.r}, ${mobButtonColor?.g}, ${mobButtonColor?.b}, ${mobButtonColor?.a})`,
                                                        width: "100%",
                                                        fontSize: "calc(var(--fs-xs)*1.132075)",
                                                        marginTop: "auto",
                                                        cursor: 'default'
                                                    }}
                                                    textStyle={{
                                                        fontSize: "calc(var(--fs-xs)*1.132075)",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div
                                    style={{
                                        width: "100%",
                                        padding: "calc(var(--sp-md2) * 1.132075) 0 0 0",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "calc(var(--sp-xxs) * 2)",
                                    }}
                                >
                                    <Typography
                                        style={{
                                            marginRight: "calc(var(--sp-xxs) * 2)",
                                            fontSize: "calc(var(--fs-xs)*1.2075471)",
                                            fontWeight: showSignInScreen ? "bold" : "normal",
                                            color: showSignInScreen ? "#111" : "#888"

                                        }}
                                    >
                                        {t('signInScreen')}
                                    </Typography>
                                    <IOSSwitch
                                        checked={!showSignInScreen}
                                        onChange={() => setShowSignInScreen((prev) => !prev)}
                                        inputProps={{ 'aria-label': 'ant design' }}
                                    />
                                    <Typography
                                        style={{
                                            marginLeft: "calc(var(--sp-xxs) * 2)",
                                            fontSize: "calc(var(--fs-xs)*1.2075471)",

                                            fontWeight: showSignInScreen ? "normal" : "bold",
                                            color: showSignInScreen ? "#888" : "#111"
                                        }}
                                    >
                                        {t('forgotPassword')}
                                    </Typography>
                                </div>
                            </div>
                        )}
                        {type === "order" && <div
                            style={{
                                width: "50%",
                                maxWidth: "calc(var(--fs-hero)*7.075471)",
                                height: `100%`,
                                backgroundColor: "#fff",
                                display: "flex",
                                flexDirection: "column",

                            }}
                        >
                            <div
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    border: "1px solid #ddd",
                                }}
                            >
                                <div
                                    style={{
                                        width: "100%",
                                        height: "20%",
                                        backgroundColor: whiteLabel?.mobile_top_banner_color || `rgba(${mobTopBannerColor?.r}, ${mobTopBannerColor?.g}, ${mobTopBannerColor?.b}, ${mobTopBannerColor?.a})`,
                                        padding: "calc(var(--sp-md2)*1.886792)",
                                        paddingBottom: "calc(var(--sp-lg)*1.886792)",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "flex-end"
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            width: "calc(var(--sp-lg)*1.415094)",
                                            height: "calc(var(--sp-lg)*1.415094)",
                                            justifyContent: "center",
                                            alignItems: "center"
                                        }}
                                    >
                                        <ArrowBackIosIcon style={{ color: "#fff", fontSize: "calc(var(--fs-xl)*1.132075)" }} />
                                    </div>
                                    <div
                                        style={{
                                            textTransform: "uppercase",
                                            color: "#fff",
                                            fontWeight: "600",
                                            fontSize: 'calc(var(--fs-xs)*1.50943)'
                                        }}
                                    >
                                        {translate('createOrder')}
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            width: "calc(var(--sp-lg)*1.415094)",
                                            height: "calc(var(--sp-lg)*1.415094)",
                                            justifyContent: "center",
                                            alignItems: "center"
                                        }}
                                    >
                                        <NotificationsIcon style={{ color: "#fff", fontSize: "calc(var(--fs-xl)*1.132075)" }} />
                                    </div>
                                </div>
                                <div
                                    style={{
                                        width: "100%",
                                        height: "85%",
                                        marginTop: "-5%",
                                        borderTopRightRadius: "calc(var(--sp-md2)*1.886792)",
                                        borderTopLeftRadius: "calc(var(--sp-md2)*1.886792)",
                                        backgroundColor: `rgba(${orderBackgroundColor?.r}, ${orderBackgroundColor?.g}, ${orderBackgroundColor?.b}, ${orderBackgroundColor?.a})`,
                                        padding: "calc(var(--sp-md2)*1.886792)",
                                        display: "flex",
                                        flexDirection: "column",
                                        overflowY: "auto"
                                    }}
                                >
                                    {
                                        orderForm?.map(order => (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    marginBottom: "calc(var(--sp-md2)*1.886792)"
                                                }}
                                            >
                                                <span style={{ fontSize: 'calc(var(--fs-xs)*1.50943)' }}>{order?.label}</span>
                                                <input
                                                    disabled
                                                    placeholder={order?.placeholder || `Enter ${order?.label}`}
                                                    style={{
                                                        height: "calc(var(--fs-xl)*1.886792)",
                                                        backgroundColor: "#fff",
                                                        border: "none",
                                                        marginBottom: "calc(var(--sp-md2)*1.886792)",
                                                        fontSize: 'calc(var(--fs-xs)*1.132075) !important',
                                                    }}
                                                    id="input"
                                                />
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>}
                        {type === "email" && <div
                            style={{
                                width: "100%",
                                height: `100%`,
                                backgroundColor: `rgba(${emailBackgroundColor?.r}, ${emailBackgroundColor?.g}, ${emailBackgroundColor?.b}, ${emailBackgroundColor?.a})`,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                                border: "1px solid #ddd"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    width: "70%",
                                    height: "70%",
                                    backgroundColor: "#fff",
                                    borderRadius: "calc(var(--sp-xs)*1.0)",
                                    flexDirection: "column",
                                    border: "1px solid #d1d1d1"
                                }}
                            >
                                <div
                                    style={{
                                        height: "50%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}
                                >
                                    <img style={{ width: "auto", height: "100%" }} src={imageUrl(emailLogo)} alt="logo" />
                                </div>
                                <div
                                    style={{
                                        padding: "calc(var(--sp-md2)*1.886792) calc(var(--sp-lg)*1.886792)",
                                        fontSize: 'calc(var(--fs-xs)*1.50943)'
                                    }}
                                >
                                    <p>{t('hello')} ,</p>
                                    <p>{t('sampleContent')}</p>
                                </div>
                            </div>
                            <table role="presentation" border="0" cellpadding="0" cellspacing="0">
                                <tr>
                                    <td class="content-block" align="center">
                                        <span class="site-link">
                                            <a style={{ fontWeight: "bold", color: "#fab316", textDecoration: "underline", fontSize: 'calc(var(--fs-xs)*1.50943)' }}>{ENV.CURRENT_HOST}</a>
                                        </span>
                                        <br />
                                        <span style={{ color: "rgb(153, 153, 153)", fontSize: "calc(var(--fs-xs)*1.132075)" }}>{emailTemplate.address_line_1}, {emailTemplate.address_line_2}, {emailTemplate.city}, {emailTemplate.state}, {emailTemplate.zip_code}, {emailTemplate.country}</span>
                                        <br />
                                        <span style={{ color: "rgb(153, 153, 153)", fontSize: "calc(var(--fs-xs)*1.132075)" }}>Contact Number: {emailTemplate.contact_number}</span>
                                    </td>
                                </tr>
                            </table>
                        </div>}
                    </div>
                    <div
                        style={{
                            width: "100%",
                            height: "10%",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}
                    >
                        <ButtonGradient
                            title="Cancel"
                            onClick={onClose}
                        />
                        <ButtonGradient
                            title="Submit"
                            onClick={onSubmit}
                            loading={loading}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    )
};

export default PreviewModal;